	export enum MemberIdRequiredTypeEnum {
		NotRequired = 0,
		RequiredOnlyForInsuranceBenefit = 1,
		AlwaysRequired = 2
	}
